import { useGLTF } from "@common/hooks/useGLTF"
import { TouchPoint } from "./Labels"
import { useStore } from "@state/store"
import { CAM_POSITION_INDEX } from "@data/cameraData"
import { useCanvasStore } from "@state/canvasStore"

const BuildingTouchPoints = () => {
  const { nodes: model } = useGLTF(
    "/assets/models/vivid_reality_logo_3d_model/scene.glb",
  ) as any

  const syncState = useStore((s) => s.syncState)
  const setCameraData = useCanvasStore((s) => s.setCameraData)
  const filteredUnits = useStore((s) => s.filteredUnits)
  const selectedUnit = useStore((s) => s.selectedUnit)
  const controlsVisible = useStore((s) => s.controlsVisible)
  const residencePopup = useStore((s) => s.residencePopup)

  const listUnits = (list, blockname) => {
    // list.forEach((unit) => {})
    return list.filter((unit) => {
      return unit?.unitName.includes(blockname)
    })
  }

  const handleClickTouchPoint = (phase: "phase1" | "phase2") => {
    if (phase === "phase1") setCameraData(CAM_POSITION_INDEX.corner)
    else if (phase === "phase2") setCameraData(CAM_POSITION_INDEX.phase2)
    syncState({ controlsVisible: true, selectedPhase: phase })
  }

  const data = {
    "0": {
      positions: { x: 0.9, y: 0.45, z: 0.1 },
      title: "The Corner Collection:",
      value: 15,
    },
    "1": {
      positions: { x: 0.29, y: 0.45, z: 0.5 },
      title: "The Cherry Collection:",
      value: 63,
    },
  }
  if (controlsVisible || selectedUnit?.[0] || residencePopup) return null
  return (
    <>
      <TouchPoint
        data={data["0"]}
        model={model}
        index={1}
        handleClickTouchPoint={() => handleClickTouchPoint("phase1")}
      />
      <TouchPoint
        data={data["1"]}
        model={model}
        index={2}
        handleClickTouchPoint={() => handleClickTouchPoint("phase2")}
      />
    </>
  )
}

export default BuildingTouchPoints
